<template>
  <div class="home ">
    <section>
      <Logo />
    </section>
    <footer>
      Hlutur AS - IoT - Program utvikling - Opplæring - Fagreiser - Workshops
    </footer>
  </div>
</template>

<script>
import Logo from "@/components/HluturLogo.vue";

export default {
  name: "Home",
  components: {
    Logo
  }
};
</script>

<style scoped>
.home {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

section {
  height: 95vh;
}

footer {
  background-color: #2c3e50;
  color: whitesmoke;
  width: 100%;
  height: 5vh;
  text-align: center;
  padding-top: 10px;
}
</style>
